import { BaseListResponse, ListItemLoader, RequestFactory, RequestSender } from '../core'

export { BaseListResponse, ListItemLoader, RequestSender }

export const KajikiRequestFactory = new RequestFactory({
  baseUrl: process.env.MEKAJIKI_BASE_URL,
  timeout: 10000,
  contentType: 'application/json',
  withCredentials: true
})

export interface BaseApiRequest {
  page?: number
  perPage?: number
}

export interface BaseApiRequestParams {
  page?: number | ''
  perPage?: number | ''
}

export function mapToRequestParams<T extends BaseApiRequest>(request: T): BaseApiRequestParams {
  const param: BaseApiRequestParams = {}
  if (request.page) {
    param.page = request.page
  }
  if (request.perPage) {
    param.perPage = request.perPage
  }
  return param
}
